import React, {useState, useEffect} from "react";
import BaseForm from "../../app/components/BaseForm";
import Input from "../../app/components/Input";
import Select from "../../app/components/Select";
import CheckBox from "../../app/components/CheckBox";


const FormEditList = ({isOpen, onClose, title, selectOrder, onSubmit}) => {

    const [formData, setFormData] = useState({
        nome: '',
        sequencia: '',
        departamento: '',
        prazo_interno: '',
        vencimento: '',
        nivel: '',
        prazo_fixo: '',
        envia_email: false,
        tipo_data: '',
        lembrar_responsavel: '',
    })

    useEffect(() => {
        if (selectOrder) {
            setFormData({
              id: selectOrder.id || null,
              nome: selectOrder.nome || '',
              sequencia: selectOrder.sequencia || '',
              departamento: selectOrder.departamento || '',
              prazo_interno: selectOrder.prazo_interno || '',
              vencimento: selectOrder.vencimento || '',
              lembrar_responsavel: selectOrder.lembrar_responsavel || '',
              nivel: selectOrder.nivel || '',
              prazo_fixo: selectOrder.prazo_fixo || '',
              tipo_data: selectOrder.tipo_data || '',
              envia_email: selectOrder.envia_email === 'Sim',
              envia_whatsapp: selectOrder.envia_whatsapp === 'Sim',
              passivel_multa: selectOrder.passivel_multa === 'Sim',
              recorrente: selectOrder.recorrente === 'Sim',
                });
            } else {
                setFormData({
                  nome: '',
                  sequencia: '',
                  departamento: '',
                  prazo_interno: '',
                  vencimento: '',
                  lembrar_responsavel: '',
                  nivel: '',
                  prazo_fixo: '',
                  tipo_data: '',
                  envia_email: false,
                  envia_whatsapp: false,
                  passivel_multa: false,
                  recorrente: false,
            });
          }
        }, [selectOrder]);

    const handleChange = (eOrValue, fieldName) => {
        if (typeof eOrValue === 'object' && eOrValue !== null && 'value' in eOrValue) {
            setFormData(prev => ({
              ...prev,
              [fieldName]: eOrValue.value,
            }))} else {
        const { name, value } = eOrValue.target;
        setFormData(prev => ({
          ...prev,
          [name]: value,
        }));
      };
    }

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
        ...prev,
        [name]: checked,
        }));
    }

    const sequenceOptions = [
        {value: '1', label: 'Controle de Desenvolvimento'},
        {value: '2', label: 'Gerenciamento de Sucesso do Cliente'},
        {value: '3', label: 'Implantação'},
        {value: '4', label: 'Banco de Talentos'},
        {value: '5', label: 'Vendas e Negociações'},
        {value: '6', label: 'Ordens de Serviço'},
        {value: '7', label: 'Controle de Atualizações'},
        {value: '8', label: 'Padrão 2'}
    ]

    const departmentOptions = [
        {value: '3', label: 'Desenvolvimento'},
        {value: '4', label: 'Deploy e Testes'},
        {value: '5', label: 'Sucesso'},
        {value: '6', label: 'Comercial'},
        {value: '7', label: 'RH'},
    ]

    const levelOptions = [
        {value: '1', label: 'Nível 1 - Baixa Complexidade'},
        {value: '2', label: 'Nível 2 - Média Complexidade'},
        {value: '3', label: 'Nível 3 - Alta Complexidade'},
    ]

    const fixedDeadlineOptions = [
        {value: 'dia_anterior', label: 'Antecipar para o dia útil anterior'},
        {value: 'dia_exato', label: 'Manter o dia exato'},
        {value: 'proximo_dia', label: 'Postergar para o próximo dia útil'},
    ]


    const typeDayOptions = [
        {value: 'dias_uteis', label: 'Dias Úteis'},
        {value: 'dias_corridos', label: 'Dias Corridos'},
    ]

    const internalDeadlineOptions = [
        ...Array.from({ length: 12 }, (_, i) => ({
          value: `${i + 1}h`,
          label: `${i + 1} hora${i + 1 > 1 ? 's' : ''}`
        })),
        ...Array.from({ length: 30 }, (_, i) => ({
          value: `${i + 1}d`,
          label: `${i + 1} dia${i + 1 > 1 ? 's' : ''}`
        }))
      ];

      const handleSubmit = (e) => {
        e.preventDefault();
        if (onSubmit && typeof onSubmit === 'function') {
          const formattedData = {
            ...formData,
            envia_email: formData.envia_email ? 'Sim' : 'Não',
            envia_whatsapp: formData.envia_whatsapp ? 'Sim' : 'Não',
            passivel_multa: formData.passivel_multa ? 'Sim' : 'Não',
            recorrente: formData.recorrente ? 'Sim' : 'Não',
          };
          onSubmit(formattedData);
        }
      };



    const renderFormField = () =>{
        return(
            <div>
                <div className='pb-4'>
                    <Input className="mt-2"
                    label={'Nome da ordem de serviço'}
                    name='nome'
                    placeholder="Digite o nome da ordem de serviço..."
                    value={formData.nome}
                    onChange={handleChange}
                    />
                </div>
                <div className='pb-4'>
                    <Select
                    label='Sequencia'
                    placeholder="Selecione a sequencia"
                    name='sequencia'
                    options={sequenceOptions}
                    value={formData.sequencia}
                    onChange={handleChange}
                    className="mt-2"
                    />
                </div>
                <div className='pb-4'>
                    <Select
                    placeholder="Selecione o departamento"
                    name='departamento'
                    label='Departamento'
                    options={departmentOptions}
                    value={formData.departamento}
                    onChange={handleChange}
                    className="mt-2" 
                    />
                </div>
                <div className='pb-4'>
                    <Select
                    label='Prazo interno'
                    placeholder="Selecione"
                    name='prazo_interno'
                    options={internalDeadlineOptions}
                    value={formData.prazo_interno}
                    onChange={handleChange}
                    className="mt-2" 
                    />
                </div>
                <div className='pb-4'>
                    <Select
                    label='Vencimento'
                    placeholder="Selecione"
                    name='vencimento'
                    options={internalDeadlineOptions}
                    value={formData.vencimento}
                    onChange={handleChange}
                    className="mt-2" 
                    />
                </div>
                <div className='pb-4'>
                    <Select
                    label='Lembrar responsável quantos dias/horas antes'
                    placeholder="Selecione"
                    name='lembrar_responsavel'
                    options={internalDeadlineOptions}
                    value={formData.lembrar_responsavel}
                    onChange={handleChange}
                    className="mt-2"
                    />
                </div>
                <div className='pb-4'>
                    <p className="text-xs ml-1 mt-1 text-gray-500">Escolha se o lembrete será em dias úteis ou corridos</p>
                    <Select
                    label='Tipo de datas'
                    placeholder="Selecione o tipo de dias"
                    options={typeDayOptions}
                    name='tipo_data'
                    value={formData.tipo_data}
                    onChange={handleChange}
                    className="mt-2" 
                    />
                </div>
                <div className='pb-4'>
                    <p className="text-xs ml-1 mt-1 text-gray-500">Defina como tratar os prazos que caem em dias não úteis</p>
                    <Select
                    label='Prazos fixos'
                    placeholder="Selecione o prazo fixo"
                    options={fixedDeadlineOptions}
                    name='prazo_fixo'
                    value={formData.prazo_fixo}
                    onChange={handleChange}
                    className="mt-2" 
                    />
                </div>
                <div className='pb-4'>
                    <Select
                    label='Nível'
                    placeholder="Selecione o nível"
                    options={levelOptions}
                    name='nivel'
                    value={formData.nivel}
                    onChange={handleChange}
                    className="mt-2" 
                    />
                </div>
                <CheckBox title={'Envia email'} 
                    onChange={handleCheckboxChange}
                    checked={formData.envia_email}
                    name={'envia_email'}/>
                <CheckBox title={'Envia Whatsapp'} 
                    onChange={handleCheckboxChange}
                    checked={formData.envia_whatsapp}
                    name={'envia_whatsapp'}
                    />
                <CheckBox 
                    title={'Passível de multa'} 
                    onChange={handleCheckboxChange}
                    name={'passivel_multa'}
                    checked={formData.passivel_multa}/>
                <CheckBox title={'Recorrente'} 
                    onChange={handleCheckboxChange}
                     name={'recorrente'}
                    checked={formData.recorrente}/>
                        
            </div>
        )
    }
    return (
        <BaseForm
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={handleSubmit}
        title={title}
        className='max-w-4xl'
        >
            {renderFormField()}
        </BaseForm>
    )
}

export default FormEditList